import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.replace";
var queue = [];
var flushTimer;

var flush = function flush() {
  if (__SERVER__) {
    throw new Error('cannot flush() on the server');
  }

  if (!queue.length) {
    return;
  }

  var request = new XMLHttpRequest();
  request.open('POST', '/_jot', true);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send(JSON.stringify(queue));
  queue.length = 0;
};

var debouncedFlush = function debouncedFlush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
  }

  flushTimer = setTimeout(function () {
    flush();
    flushTimer = null;
  }, 250);
};

var sanitizeForGraphite = function sanitizeForGraphite(str) {
  return String(str).replace(/\./, '-');
};

var prefix = function prefix(client) {
  return "".concat(client ? "".concat(client, ".") : '', "api");
};

var increment = function increment(name) {
  if (__SERVER__ && global.statsd) {
    global.statsd.increment(name);
  } else if (__CLIENT__) {
    queue.push(['increment', name]);
    debouncedFlush();
  }
};

var histogram = function histogram(name, duration) {
  if (__SERVER__ && global.statsd) {
    global.statsd.histogram(name, duration);
  } else if (__CLIENT__) {
    queue.push(['histogram', name, duration]);
    debouncedFlush();
  }
};

var trackApiRequest = function trackApiRequest(client, event) {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console

    return;
  } // counter: <namespace>.<client name>.api.<name>.requested
  // counter: <namespace>.<client name>.api._global.requested


  increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), ".").concat(sanitizeForGraphite(event.name.toLowerCase()), ".requested"));
  increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), "._global.requested"));
};

var trackApiResult = function trackApiResult(client, event) {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console

    return;
  } // timer: <namespace>.<client name>.api.<verb>.<name>.response_time
  // timer: <namespace>.<client name>.api.<verb>._global.response_time


  histogram("".concat(prefix(client), ".").concat(event.method.toLowerCase(), ".").concat(sanitizeForGraphite(event.name.toLowerCase()), ".response_time"), event.duration);
  histogram("".concat(prefix(client), ".").concat(event.method.toLowerCase(), "._global.response_time"), event.duration); // counter: <namespace>.<client name>.api.<verb>.<name>.http.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.http.<code>

  if (event.httpStatus) {
    increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), ".").concat(sanitizeForGraphite(event.name.toLowerCase()), ".http.").concat(event.httpStatus));
    increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), "._global.http.").concat(event.httpStatus));
  } // counter: <namespace>.<client name>.api.<verb>.<name>.error.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.error.<code>


  if (event.code) {
    increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), ".").concat(sanitizeForGraphite(event.name.toLowerCase()), ".error.").concat(event.code));
    increment("".concat(prefix(client), ".").concat(event.method.toLowerCase(), "._global.error.").concat(event.code));
  }
};

export { increment };
export { histogram };
export { flush };
export { trackApiRequest };
export { trackApiResult };